
export default {
  data: () => ({

    localData: {
      // Skyline
      JSON1: [ 
        {      
          BOX_WIDTH:              28,
          BOX_HEIGHT:             15,
          BOX_GAP:                2, 
          BOX_TEXT_SIZE:          8.5,

          // Legends 
          LEGEND_X:               45,
          LEGEND_Y:               80,
          BAR_HEIGHT:             75,
        }
      ],


      // Checksheet
      // Finish
      JSON2: [ 
        {
          TITLE:            ' Cutting  / FAB.     / Assembly / Painting  / Setting  ',
          SCHEDULE:         ' Finish   / Finish   / Finish   / Finish    / Finish   ',
          JPG:              '          /          /          / A_        / C_       ',
          COLUMN:           ' BLK      / BLK      / BLK      / PE1       / EREC     ',
          REF:              ' SC_PF    / FB_PF    / AS_PF    / PT_PF     / ER_PF    ',
          REF2:             ' SC_AF    / FB_AF    / AS_AF    / PT_AF     / ER_AF    ',
          PRO:              ' SC_AP    / FB_AP    / AS_AP    / PT_AP     / ER_AP    ',
          COLOR:            ' #E0E0DF  / #FEED57  / #83D2F5  / #F7BACF   / #8BC248  ',
          WIDTH:            ' 31       / 31       / 31       / 31        /  31       ',
          START:            ' 0        / 1        / 1        / 1         /  2        ',
          END:              ' 0        / 1        / 1        / 1         /  2        ',
          JSON:             ' CUT      / FAB      / ASS      / PE1       /  EREC     ',
        }
      ],

      // Start
      JSON3: [ 
        {
          TITLE:            ' Cutting  / FAB.     / Assembly / Painting  / Setting  ',
          SCHEDULE:         ' Start    / Start    / Start    / Start     / Start    ',
          JPG:              '          /          /          / A_        / C_       ',
          COLUMN:           ' BLK      / BLK      / BLK      / PE1       / EREC     ',
          REF:              ' SC_PS    / FB_PS    / AS_PS    / PT_PS     / ER_PS    ',
          REF2:             ' SC_AS    / FB_AS    / AS_AS    / PT_AS     / ER_AS    ',
          PRO:              ' SC_AP    / FB_AP    / AS_AP    / PT_AP     / ER_AP    ',
          COLOR:            ' #E0E0DF  / #FEED57  / #83D2F5  / #F7BACF   / #8BC248  ',
          WIDTH:            ' 31       / 31       / 31       / 31        /  31       ',
          START:            ' 0        / 2        / 2        / 2         /  3        ',
          END:              ' 0        / 2        / 2        / 2         /  3        ',
          JSON:             ' CUT      / FAB      / ASS      / PE1       /  EREC     ',
        }
      ],


      
    }
  }),
}